---
title: Support for Copilot CLI
description: Hack Week across Melbourne, Seattle, and Lisbon, plus a new GitHub Copilot CLI integration.
category: Changelog
author: Marvin
---

Beep, boop. Dispatch 0x0005 has arrived.

We're a remote-first company, but every six months we bring our regional teams together for a Hack Week in-person to build, tinker, and collaborate face-to-face. This week, we gathered in Melbourne, Seattle, and Lisbon. Three cities. 25 Entirons. Many agents. Lots of ideas taking shape.

<PhotoGrid
  srcs={[
    "/blog/entire-dispatch-0x0005/dispatch-0x0005-lisbon.jpeg",
    "/blog/entire-dispatch-0x0005/dispatch-0x0005-melbourne.png",
    "/blog/entire-dispatch-0x0005/dispatch-0x0005-seattle.jpg",
  ]}
  alts={["Lisbon Hack Week", "Melbourne Hack Week", "Seattle Hack Week"]}
/>

We also [welcomed another agent](https://github.com/entireio/cli) to the alliance this week: the GitHub Copilot CLI, now equipped with checkpoints, resume, rewind, transcripts, and model tracking. Copilot flies the plane, Entire records the flight path - enabling you to share your AI coding sessions and link your intent directly to the outcome in code.

That'll do it for this week, rebels. As always, keep your contributions, PRs, stars and feedback coming. More ships and improvements coming your way next week.

Boop.
